import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "spike_cookie_consent_v1";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      const v = window.localStorage.getItem(STORAGE_KEY);
      if (!v) setShow(true);
    } catch {
      setShow(true);
    }
  }, []);

  const accept = () => {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ accepted_at: new Date().toISOString() }));
    } catch {}
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-md z-[60] bg-spike-elevated border border-spike-blue/30 rounded-lg shadow-2xl p-4 flex flex-col gap-3"
    >
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-spike-blue-light shrink-0 mt-0.5" />
        <p className="text-sm text-spike-text leading-relaxed">
          We use essential cookies to keep you signed in and to remember your preferences. By using this site
          you agree to our{" "}
          <Link to="/privacy" className="text-spike-blue-light underline" data-testid="cookie-privacy-link">
            Privacy Policy
          </Link>
          .
        </p>
      </div>
      <button
        type="button"
        data-testid="cookie-accept-btn"
        onClick={accept}
        className="self-end bg-spike-blue hover:bg-spike-blue-hover text-black font-orbitron font-bold uppercase tracking-[0.18em] text-[0.7rem] px-5 py-2.5 rounded-sm transition-colors"
      >
        Accept
      </button>
    </div>
  );
};

export default CookieBanner;
